/** Client-side catalog/moodboard filtering. Pure — keeps the admin views thin. */

export function filterPieces<T extends { name: string; category: string; is_active: boolean }>(
  pieces: T[],
  f: { query: string; category: string | null; activeOnly: boolean },
): T[] {
  const q = f.query.trim().toLowerCase();
  return pieces.filter((p) => {
    if (q && !p.name.toLowerCase().includes(q)) return false;
    if (f.category && p.category !== f.category) return false;
    if (f.activeOnly && !p.is_active) return false;
    return true;
  });
}

export function filterMoodboards<T extends { name: string; id: string }>(
  boards: T[],
  f: { query: string; incompleteOnly: boolean },
  isComplete: (id: string) => boolean,
): T[] {
  const q = f.query.trim().toLowerCase();
  return boards.filter((b) => {
    if (q && !b.name.toLowerCase().includes(q)) return false;
    if (f.incompleteOnly && isComplete(b.id)) return false;
    return true;
  });
}
